import { render, staticRenderFns } from "./tp3Edit.vue?vue&type=template&id=1b94d5d4"
import script from "./tp3Edit.vue?vue&type=script&lang=js"
export * from "./tp3Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports